export class DialogModel {
    public title: string;
    public messageList: string[];
    public buttonText: string;

    constructor();
    constructor(title: string, messageList: string[], buttonText: string);
    constructor(title?: string, messageList?: string[], buttonText?: string) {
        if (title) {
            this.title = title;
            this.messageList = messageList;
            this.buttonText = buttonText;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dialog/dialog.model.ts